import { FileWithPath } from 'react-dropzone';

import { createModalStore } from '@/shared/lib/modal';

type CreateProjectModalProps = {
  files?: FileWithPath[];
  isFirstProject?: boolean;
  isSample: boolean;
  presetName?: string;
  presetRecordingId?: string;
  presetSourceUrl?: string;
};

const initialState: CreateProjectModalProps = {
  files: undefined,
  isFirstProject: false,
  isSample: false,
  presetName: undefined,
  presetRecordingId: undefined,
  presetSourceUrl: undefined,
};

export const useCreateProjectModalStore = createModalStore<CreateProjectModalProps>(initialState, false);
